import * as React from 'react';

import { PromoBlocks } from '../../components/promo_blocks/promo_blocks';
import { IMainPage } from '../../models/mainpage';
import { IPromo } from '../../models/promo';
import { IPromoBanner, IPromoBlock } from '../../models/promo_block';
import { APPEARANCE, COMPOSITION, IMAGES, POSITIONS, SIZES, XS_SIZES } from './composition_config';
import { trackLink } from '../../helpers/metrics_helper';

import { connect } from 'react-redux';

interface IProps {
  promo: IPromo[];
  isFetching: boolean;
  subdomainRegionId: number;
}

interface IState {
  promoBlocks: IPromoBlock[];
  promoBanner: IPromoBanner;
}

class Promo extends React.Component<IProps, IState> {

  public componentWillMount() {
    this.updateState(this.props);
  }

  public componentWillReceiveProps(newProps: IProps) {
    this.updateState(newProps);
  }

  public render() {
    if (this.props.promo.length > 0) {
      return (
        <PromoBlocks
          {...this.state}
          isFetching={this.props.isFetching}
          onLinkClick={(url) => trackLink(url)}
          subdomainRegionId={this.props.subdomainRegionId}
        />
      );
    } else {
      return (<div/>);
    }
  }

  private updateState(newProps: IProps) {
    const promo = newProps.promo.slice();
    let jkBanner: IPromo | undefined;
    if (promo.length && promo[promo.length - 1].id === 'indexJkBanner') {
      jkBanner = promo.pop();       // last block may has special purpose
    }
    promo.sort((a: IPromo, b: IPromo) => POSITIONS[a.id] - POSITIONS[b.id]);
    const count = promo.length;
    const composition = COMPOSITION[count];
    const imageAppearance = APPEARANCE[count];
    const sizes = SIZES[count];
    const xsSizes = XS_SIZES[count];
    const promoBanner: IPromoBanner = {
      size: sizes[sizes.length - 1],
      xsSize: xsSizes[xsSizes.length - 1],
      promo: jkBanner,
    };
    const promoBlocks: IPromoBlock[] = promo.map((promoInfo: IPromo, i: number) => ({
      promo: promoInfo,
      imagePosition: composition[i],
      imageUrl: IMAGES[promoInfo.id],
      imageAppearance: imageAppearance[i],
      size: sizes[i],
      xsSize: xsSizes[i],
    }));
    this.setState({
      promoBlocks,
      promoBanner,
    });
  }

}

const PromoWrapper = connect((state: { mainpage: IMainPage }) => ({
  promo: state.mainpage.promoBlocks,
  isFetching: state.mainpage.isFetching,
  subdomainRegionId: state.mainpage.regionsData.subdomainRegionId,
}))(Promo);

export { PromoWrapper as Promo, Promo as PromoClass };
